import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { SalesActivityModuleState } from "../../..";

export enum VendorClientActionTypes {
	SHOW_VENDOR_CLIENT_LOADER = "SHOW_VENDOR_CLIENT_LOADER",
	HIDE_VENDOR_CLIENT_LOADER = "HIDE_VENDOR_CLIENT_LOADER",
	OPEN_EDIT_VENDOR_CLIENT_DRAWER = "OPEN_EDIT_VENDOR_CLIENT_DRAWER",
	CLOSE_EDIT_VENDOR_CLIENT_DRAWER = "CLOSE_EDIT_VENDOR_CLIENT_DRAWER"
}

export type ShowVendorClientLoaderAction =
	Action<VendorClientActionTypes.SHOW_VENDOR_CLIENT_LOADER>;
export type HideVendorClientLoaderAction =
	Action<VendorClientActionTypes.HIDE_VENDOR_CLIENT_LOADER>;

export type OpenEditVendorClientDrawerAction =
	Action<VendorClientActionTypes.OPEN_EDIT_VENDOR_CLIENT_DRAWER>;
export type CloseEditVendorClientDrawerAction =
	Action<VendorClientActionTypes.CLOSE_EDIT_VENDOR_CLIENT_DRAWER>;

export type VendorClientActions =
	| ShowVendorClientLoaderAction
	| HideVendorClientLoaderAction
	| OpenEditVendorClientDrawerAction
	| CloseEditVendorClientDrawerAction;

export interface VendorClientDispatch {
	showVendorClientLoader: ActionCreator<
		ThunkAction<
			ShowVendorClientLoaderAction,
			SalesActivityModuleState,
			null,
			ShowVendorClientLoaderAction
		>
	>;
	hideVendorClientLoader: ActionCreator<
		ThunkAction<
			HideVendorClientLoaderAction,
			SalesActivityModuleState,
			null,
			HideVendorClientLoaderAction
		>
	>;
	openEditVendorClientDrawer: ActionCreator<
		ThunkAction<
			OpenEditVendorClientDrawerAction,
			SalesActivityModuleState,
			null,
			OpenEditVendorClientDrawerAction
		>
	>;
	closeEditVendorClientDrawer: ActionCreator<
		ThunkAction<
			CloseEditVendorClientDrawerAction,
			SalesActivityModuleState,
			null,
			CloseEditVendorClientDrawerAction
		>
	>;
}

export const VendorClientActionCreators: VendorClientDispatch = {
	showVendorClientLoader: () => {
		return (dispatch: Dispatch): ShowVendorClientLoaderAction => {
			const showVendorOpportunityLoaderAction: ShowVendorClientLoaderAction =
				{
					type: VendorClientActionTypes.SHOW_VENDOR_CLIENT_LOADER
				};
			return dispatch(showVendorOpportunityLoaderAction);
		};
	},
	hideVendorClientLoader: () => {
		return (dispatch: Dispatch): HideVendorClientLoaderAction => {
			const hideVendorOpportunityLoaderAction: HideVendorClientLoaderAction =
				{
					type: VendorClientActionTypes.HIDE_VENDOR_CLIENT_LOADER
				};
			return dispatch(hideVendorOpportunityLoaderAction);
		};
	},
	openEditVendorClientDrawer: () => {
		return (dispatch: Dispatch): OpenEditVendorClientDrawerAction => {
			const openOpportunityDrawerAction: OpenEditVendorClientDrawerAction =
				{
					type: VendorClientActionTypes.OPEN_EDIT_VENDOR_CLIENT_DRAWER
				};
			return dispatch(openOpportunityDrawerAction);
		};
	},
	closeEditVendorClientDrawer: () => {
		return (dispatch: Dispatch): CloseEditVendorClientDrawerAction => {
			const closeOpportunityDrawerAction: CloseEditVendorClientDrawerAction =
				{
					type: VendorClientActionTypes.CLOSE_EDIT_VENDOR_CLIENT_DRAWER
				};
			return dispatch(closeOpportunityDrawerAction);
		};
	}
};

export default VendorClientActionCreators;
